import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

class WizardNavigator extends React.Component {
  render() {
    const { t, onPrev, onNext, customPrev, customNext } = this.props;

    return (
      <div className="panel-body">
        <div className="btn-group">
          {!onPrev ? null : customPrev ? (
            customPrev
          ) : (
            <button className="btn btn-default" onClick={onPrev}>
              {t('common:commonWords.back')}
            </button>
          )}
        </div>
        <div className="btn-group pull-right">
          <div className="pull-right">
            {!onNext ? null : customNext ? (
              customNext
            ) : (
              <button className="btn btn-primary" onClick={onNext}>
                {t('common:commonWords.next')}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

WizardNavigator.propTypes = {
  onPrev: PropTypes.func,
  customPrev: PropTypes.object,
  onNext: PropTypes.func,
  customNext: PropTypes.object
};

export default withTranslation()(WizardNavigator);
